import reset from "@/util/reset";
import router from "@/router";

const taskFilter = Object.assign(
  {
    book: "",
    bookPackage: "",
    chapter: "",
    competenceModules: "",
    name: "",
    schoolSubjects: "",
    schoolTypes: "",
    skills: "",
    taskType: "",
    topic: "",
    deploymentStatus: ""
  },
  router.currentRoute.query
);

export default {
  books: [],
  bookPackages: [],
  chapters: [],
  competenceModules: [],
  schoolSubjects: [],
  schoolTypes: [],
  skills: [],
  tasks: [],
  taskTypes: [],
  topics: [],
  filter: [],
  contentTypes: [],
  basicFilter: {
    SCHOOL_TYPE: "",
    COMPETENCE_MODULE: "",
    SCHOOL_SUBJECT: "",
    TASK_TYPE: "",
    BOOK: ""
  },
  current: {
    BOOK: reset.BOOK(),
    BOOK_PACKAGE: reset.BOOK_PACKAGE(),
    CHAPTER: reset.CHAPTER(),
    COMPETENCE_MODULE: reset.COMPETENCE_MODULE(),
    SCHOOL_SUBJECT: reset.SCHOOL_SUBJECT(),
    SCHOOL_TYPE: reset.SCHOOL_TYPE(),
    SKILL: reset.SKILL(),
    TASK: reset.TASK(),
    TASK_TYPE: reset.TASK_TYPE(),
    TOPIC: reset.TOPIC(),
    FILTER: reset.FILTER(),
    CONTENT_TYPE: reset.CONTENT_TYPE()
  },
  taskFilter,
  names: {
    taskNames: [],
    taskTypeNames: [],
    skillNames: [],
    chapterNames: [],
    bookPackageNames: [],
    topicNames: [],
    bookNames: [],
    schoolTypeNames: []
  },
  meta: {
    taskCount: 0,
    taskPages: 1
  },
  taskCurrentPage: 1,
  hasMoreTasks: true,
  loadingMoreTasks: false,
  deploymentResults: [],
  faqs: []
};
